import React, { useEffect, useState } from 'react';
import { supabase } from '../services/supabase';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

interface Notification {
  id: string;
  type: string;
  title: string;
  body: string;
  link: string;
  read_at: string | null;
  created_at: string;
}

export default function NotificationToast() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [toasts, setToasts] = useState<Notification[]>([]);

  useEffect(() => {
    if (!user) return;

    const channel = supabase
      .channel('notifications')
      .on('postgres_changes', {
        event: 'INSERT',
        schema: 'public',
        table: 'notifications',
        filter: `user_id=eq.${user.id}`
      }, (payload) => {
        const notif = payload.new as Notification;
        setToasts(prev => [...prev, notif]);
        setTimeout(() => {
          setToasts(prev => prev.filter(t => t.id !== notif.id));
        }, 6000);
      })
      .subscribe();

    return () => { supabase.removeChannel(channel); };
  }, [user]);

  const dismiss = async (id: string) => {
    setToasts(prev => prev.filter(t => t.id !== id));
    await supabase
      .from('notifications')
      .update({ read_at: new Date().toISOString() })
      .eq('id', id);
  };

  const handleClick = async (toast: Notification) => {
    await dismiss(toast.id);
    if (toast.link) navigate(toast.link);
  };

  if (toasts.length === 0) return null;

  return (
    <div style={{
      position: 'fixed', bottom: '24px', right: '24px',
      display: 'flex', flexDirection: 'column', gap: '8px',
      zIndex: 9999, maxWidth: '340px'
    }}>
      {toasts.map(toast => (
        <div
          key={toast.id}
          onClick={() => handleClick(toast)}
          style={{
            background: '#FFFFFF',
            border: '1px solid #D0D5DD',
            borderLeft: '3px solid #C9A84C',
            borderRadius: '4px',
            padding: '14px 16px',
            cursor: 'pointer',
            boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
            display: 'flex', alignItems: 'flex-start', gap: '12px'
          }}
        >
          <div style={{ fontSize: '18px', flexShrink: 0 }}>
            {toast.type === 'meeting_confirmed' ? '✅' : '❌'}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: '13px', fontWeight: 600, color: '#0A0A0A', marginBottom: '3px' }}>
              {toast.title}
            </div>
            <div style={{ fontSize: '12px', color: '#6B7280', lineHeight: 1.4 }}>
              {toast.body}
            </div>
          </div>
          <button
            onClick={e => { e.stopPropagation(); dismiss(toast.id); }}
            style={{
              background: 'transparent', border: 'none',
              color: '#6B7280', cursor: 'pointer',
              fontSize: '16px', padding: '0', lineHeight: 1, flexShrink: 0
            }}
          >×</button>
        </div>
      ))}
    </div>
  );
}